import { useEffect, useRef, useState } from "react";

import { getAdminSettings, updateEmailFrequency } from "sj-ui-toolkit/src/api";
import { useToast } from "sj-ui-toolkit/src/hooks";

import { Card } from "primereact/card";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";

const FREQUENCIES = [
  { label: "Weekly", value: "weekly" },
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
];

export const EmailFrequency = () => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(true);
  const [frequency, setFrequency] = useState<string | null>(null);

  const hasLoadedRef = useRef(false);

  useEffect(() => {
    if (hasLoadedRef.current) return;
    hasLoadedRef.current = true;

    const loadSettings = async () => {
      try {
        const { updateFrequency } = await getAdminSettings();
        setFrequency(updateFrequency);
      } catch (error) {
        console.error("Failed to load email settings:", error);
        showToast({ severity: "error", detail: "Failed to load email settings" });
      } finally {
        setLoading(false);
      }
    };

    loadSettings();
  }, []);

  const handleFrequencyChange = async (updated: string) => {
    const initial = frequency;
    try {
      setFrequency(updated);
      await updateEmailFrequency(updated);
      showToast({ severity: "success", detail: "Email frequency updated" });
    } catch (error) {
      setFrequency(initial);
      console.error("Failed to update email frequency:", error);
      showToast({ severity: "error", detail: "Failed to update email frequency" });
    }
  };

  if (loading) {
    return (
      <Card title={<Skeleton width="30%" height="3rem" />}>
        <div className="flex flex-col gap-4">
          <Skeleton width="80%" height="2rem" />
          <Skeleton width="100%" height="4rem" />
        </div>
      </Card>
    );
  }

  return (
    <Card
      title={
        <div className="flex justify-between">
          <label htmlFor="email-frequency">
            <strong>Notification Frequency</strong>
          </label>
        </div>
      }
    >
      <div className="flex flex-col gap-4">
        <Dropdown
          inputId="email-frequency"
          className="w-1/4"
          value={frequency}
          options={FREQUENCIES}
          onChange={e => void handleFrequencyChange(e.value as string)}
          placeholder="Select Frequency"
          aria-describedby="frequency-help"
        />
        <p id="frequency-help">This setting only applies to this email template.</p>
      </div>
    </Card>
  );
};
